import { QuizConfigProvider } from '@mentimeter/quiz';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { ViewOnlyPresentationDataHandler } from './ViewOnlyPresentationDataHandler';
import { LivePresentationDataHandler } from './LivePresentationDataHandler';

export function QuizOpenPresentationDataHandler() {
  const { useVotingInstructions, useConfig } = usePresentationContext();
  const { voteKey } = useVotingInstructions();
  const { mode } = useConfig();
  const { slidePublicKey, slideAdminKey } = usePresentationSlideContext();

  if (mode !== 'live') {
    return <ViewOnlyPresentationDataHandler />;
  }

  return (
    <QuizConfigProvider
      questionPublicKey={slidePublicKey}
      questionAdminKey={slideAdminKey}
      voteKey={voteKey}
    >
      <LivePresentationDataHandler />
    </QuizConfigProvider>
  );
}
